import { Link } from 'react-router';
import { LegalPageShell, LegalSection } from '../components/LegalPageShell';
import { PANEL_URL } from '../lib/api';

export default function SupportPage() {
  return (
    <LegalPageShell
      title="Wsparcie"
      subtitle="Pomoc techniczna i kontakt w sprawach konta Turnivo (panel, aplikacja mobilna, strona www)."
    >
      <LegalSection title="Kontakt">
        <p>
          E-mail:{' '}
          <a href="mailto:kontakt@turnivo.pl" className="text-[#0066FF] font-semibold hover:underline">
            kontakt@turnivo.pl
          </a>
        </p>
        <p className="mt-2">
          Strona główna:{' '}
          <Link to="/" className="text-[#0066FF] hover:underline">
            turnivo.pl
          </Link>
        </p>
        <p className="mt-2">
          Panel organizatora:{' '}
          <a href={PANEL_URL} className="text-[#0066FF] hover:underline" target="_blank" rel="noopener noreferrer">
            panel.turnivo.pl
          </a>
        </p>
      </LegalSection>

      <LegalSection title="Najczęstsze tematy">
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <Link to="/usuniecie-konta" className="text-[#0066FF] hover:underline">
              Usunięcie konta i danych
            </Link>
          </li>
          <li>
            <Link to="/polityka-prywatnosci" className="text-[#0066FF] hover:underline">
              Polityka prywatności
            </Link>
          </li>
          <li>
            <Link to="/regulamin" className="text-[#0066FF] hover:underline">
              Regulamin
            </Link>
          </li>
          <li>Problemy z logowaniem, weryfikacją e-mail lub subskrypcją</li>
          <li>Aplikacja mobilna (iOS / Android) — zgłoszenia błędów</li>
        </ul>
      </LegalSection>

      <LegalSection title="Czas odpowiedzi">
        <p>Zwykle odpowiadamy w dni robocze w ciągu 1–2 dni roboczych.</p>
      </LegalSection>
    </LegalPageShell>
  );
}
